
export function track(event: string) {
  if (typeof window.gtag === "undefined") {
    return
  }

  gtag("event", event)
}

export {}